import React, { Component }  from 'react';

const BouncingBall = () => {
  return (
    <div className="flex items-center justify-center min-h-screen text-gray-900 opacity-25">
      <span className="animate-bounce text-9xl">⚽️</span>
    </div>
  );
};

export default BouncingBall;